const survey = {
  // 네임스페이스 사용 (모듈 단위로 접근 가능)
  namespaced: true,

  // 상태 정의
  state: {
    target_idx: '', // 설문 대상 ID
    survey_idx: '', // 설문 ID
    goSurvet: false, // 설문 이동 여부 (오타 → goSurvey?)
    goTarget: false // 타겟 이동 여부
  },

  // 상태를 변경하는 동기 메서드
  mutations: {
  },

  // 비동기 로직이나 여러 mutation을 조합하는 메서드
  actions: {
  },

  // state를 가공해서 반환하는 computed 역할
  getters: {
  }
}

export default survey
